import { Injectable } from '@angular/core';

import { Observable, Subject } from 'rxjs';

import { ILanguageDirection } from '../interfaces/languageDirection.interface';
import { TranslationService } from './translation.service';

@Injectable()
export class DirectionService implements ILanguageDirection {
  private direction$: Subject<string> = new Subject();
  private rtl$: Subject<boolean> = new Subject();

  constructor(private translation: TranslationService) {
    this.translation.getSelectedLanguage().subscribe((language: any) => {
      this.direction$.next(language.direction);
      this.rtl$.next(language.rtl);
    });
  }

  public getDirection(): Observable<string> {
    return this.direction$.asObservable();
  }

  public getRTL(): Observable<boolean> {
    return this.rtl$.asObservable();
  }

  public getDirectionFor(languageCode: string) {
    const language = this.translation.getLanguage(
      languageCode.split(/[-_]/)[0]
    );
    this.direction$.next(language.dir);
  }

  public getRtlFor(languageCode: string) {
    const language = this.translation.getLanguage(
      languageCode.split(/[-_]/)[0]
    );
    this.rtl$.next(language.rtl);
  }
}
